var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUnitedKingdom = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F0F0F0",
  d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052B4",
  d: "M4.067 5.912a10 10 0 0 0-1.723 3.48h5.203zm17.588 3.479a10 10 0 0 0-1.722-3.48l-3.48 3.48zM2.344 14.609a10 10 0 0 0 1.723 3.48l3.48-3.48zM18.088 4.067a10 10 0 0 0-3.48-1.723v5.203zM5.912 19.933a10 10 0 0 0 3.48 1.723v-5.203zM9.391 2.344a10 10 0 0 0-3.48 1.723l3.48 3.48zm5.218 19.311a10 10 0 0 0 3.48-1.722l-3.48-3.48zm1.844-7.046 3.48 3.48a10 10 0 0 0 1.722-3.48z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#D80027",
  d: "M21.915 10.696h-8.61V2.085a10 10 0 0 0-2.61 0v8.61h-8.61a10 10 0 0 0 0 2.61h8.61v8.61a10 10 0 0 0 2.61 0v-8.61h8.61a10 10 0 0 0 0-2.61Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#D80027",
  d: "m14.609 14.609 4.462 4.462q.307-.308.588-.642l-3.82-3.82zm-5.218 0L4.93 19.07q.308.307.642.588l3.82-3.82zm0-5.218L4.93 4.93q-.307.308-.588.642l3.82 3.82zm5.218 0L19.07 4.93a10 10 0 0 0-.642-.588l-3.82 3.82z"
})));
export default SvgUnitedKingdom;